import React from "react";

export default class CookiePolicyPage extends React.Component {
  constructor(props) {
    super(props);

    let body = document.body;
    let wrapper = document.getElementById("page-content");

    // wrapper.classList.add("page-content-public");
    body.classList.add("dark-theme");

    this.state = {};
  }

  componentDidMount() {}

  render() {
    return (
      <React.Fragment>
        <div className="container" style={{ marginTop: 20 }}>
          <div className="row">
            <h2>Cookie Policy</h2>
          </div>
          <div className="row">
            <h2>
              <span id="A_weboldal_cookie_tájékoztatója"></span>
              <span>A weboldal cookie tájékoztatója</span>
            </h2>
          </div>
          <div className="row" style={{ marginTop: 10 }}>
            <p>
              Az alábbi cookiekat szükséges hozzáadnod a weboldal működéshez
              elengedhetetlen cookiek listájához:
            </p>
          </div>
          <div className="row" style={{ marginTop: 10 }}>
            <tbody className="wikitable">
              <tbody>
                <tr className="wikitable-tr">
                  <th>Cookie neve</th>
                  <th>Cookie leírása és célja</th>
                  <th>Szolgáltató</th>
                  <th>Mennyi ideig tárolódik az eszközödön?</th>
                </tr>
                <tr className="wikitable-tr">
                  <td>ba_vid</td>
                  <td>
                    Célja a Barion Smart Gateway szolgáltatás során a
                    bankkártyás csalások kiszűrése az általad használt eszköz
                    digitális ujjlenyomata és a böngészési szokásaid alapján. A
                    cookie használata a csalók felismeréséhez szükséges. A
                    cookie azt biztosítja, hogy a böngészési szokásaidból
                    származó adatokról tudjuk, hogy egy felhasználótól
                    származnak.
                  </td>
                  <td>
                    <a
                      rel="nofollow"
                      className="external text"
                      href="https://www.barion.com/en/privacy-notice/"
                    >
                      Barion Payment Zrt.
                    </a>
                  </td>
                  <td>Utolsó frissüléstől számított 1,5 évig.</td>
                </tr>
                <tr className="wikitable-tr">
                  <td>ba_vid.xxx</td>
                  <td>
                    Célja a a Barion Smart Gateway szolgáltatás során a
                    bankkártyás csalások kiszűrése az általad használt eszköz
                    digitális ujjlenyomata és a böngészési szokásaid alapján. A
                    cookie azt biztosítja, hogy a böngészési szokásaidat
                    követhessük két munkamenet között az adott honlapon. Ezeket
                    az adatokat gyűjti: ba_vid, userhez kapcsolódó ID, amely a
                    böngésző tulajdonságaiból összeállított hash, az alapján az
                    első, a mostani és az utolsó látogatásod időbélyeged az
                    adott honlapon, az aktuális munkamenet ID, harmadik feles
                    cookiekhoz való engedély.
                  </td>
                  <td>
                    <a
                      rel="nofollow"
                      className="external text"
                      href="https://www.barion.com/en/privacy-notice/"
                    >
                      Barion Payment Zrt.
                    </a>
                  </td>
                  <td>Utolsó frissüléstől számított 1,5 évig.</td>
                </tr>
                <tr className="wikitable-tr">
                  <td>ba_sid</td>
                  <td>
                    Célja a Barion Smart Gateway szolgáltatás során a
                    bankkártyás csalások kiszűrése az általad használt eszköz
                    digitális ujjlenyomata és a böngészési szokásaid alapján. A
                    cookie azt biztosítja, hogy a munkamenetedet azonosítani
                    tudjuk honlapokon átívelően.
                  </td>
                  <td>
                    <a
                      rel="nofollow"
                      className="external text"
                      href="https://www.barion.com/en/privacy-notice/"
                    >
                      Barion Payment Zrt.
                    </a>
                  </td>
                  <td>30 percig</td>
                </tr>
                <tr className="wikitable-tr">
                  <td>ba_sid.xxx</td>
                  <td>
                    Célja a Barion Smart Gateway szolgáltatás során a
                    bankkártyás csalások kiszűrése az általad használt eszköz
                    digitális ujjlenyomata és a böngészési szokásaid alapján. A
                    cookie azt biztosítja, hogy a böngésződ munkamenetét
                    (session) azonosítani tudjuk az adott honlapon belül.
                  </td>
                  <td>
                    <a
                      rel="nofollow"
                      className="external text"
                      href="https://www.barion.com/en/privacy-notice/"
                    >
                      Barion Payment Zrt.
                    </a>
                  </td>
                  <td>30 percig</td>
                </tr>
              </tbody>
            </tbody>
          </div>
          <div className="row" style={{ marginTop: 10 }}>
            <p>
              Ha a cookie élettartama az utolsó frissüléstől definiált, az azt
              jelenti, hogy minden egyes látogatás meghosszabítja a cookie
              lejáratát 1,5 évvel az utolsó látogatástól számítva. A
              meghosszabbításból származó adatgyűjtés nem igényel hozzájárulást.
              Az adatkezelés a Barion Payment Zrt. jogos érdeke csalás megelőzés
              céljából. További információk{" "}
              <a
                rel="nofollow"
                className="external text"
                href="https://www.barion.com/en/privacy-notice/"
              >
                itt
              </a>
              . <br />
              Egyéb technológiák: A böngésző digitális újlenyomata: Célja, hogy
              kiszűrjűk a csaló munkameneteket a látogatói viselkedés és
              böngészőjük újlenyomata alapján. Segít nekünk, hogy azonosítsuk a
              böngészőket az egyes eszközökön. Ezt az adott weboldalon és más
              kereskedők weboldalain is felhasználjuk, azoknál akik használják a
              Barion Smart Gateway-t. További részleteket az{" "}
              <a
                rel="nofollow"
                className="external text"
                href="https://www.barion.com/en/privacy-notice/"
              >
                adatkezelési tájékoztató
              </a>{" "}
              5.4 fejezetében találunk.
              <br />
            </p>
            <p>
              A következő cookiekat kell hozzáadni a marketing cookie listához,
              amelyeket marketing célra, személyreszabott tartalmakhoz és
              célzott reklám hirdetésekhez használunk.
            </p>
          </div>
          <div className="row" style={{ marginTop: 10 }}>
            <tbody className="wikitable">
              <tbody>
                <tr className="wikitable-tr">
                  <th>Cookie neve</th>
                  <th>Cookie leírása és célja</th>
                  <th>Szolgáltató</th>
                  <th>Mennyi ideig tárolódik az eszközödön?</th>
                </tr>
                <tr className="wikitable-tr">
                  <td>BarionMarketingConsent.xxx</td>
                  <td>
                    Célja azon nyilatkozatod tárolása, hogy hozzájárultál-e a
                    böngészési szokásaidból származó adatok gyűjtéséhez és a
                    vásárlási szokásaid vizsgálatához személyre szabott
                    hirdetések, ajánlatok megjelenítse érdekében. Amennyiben a
                    hozzájárultál, akkor a működéshez szükséges cookie-k között
                    elhelyezett alábbi, bankkártyás csalásmegelőzési célú
                    cookie-k által gyűjtött adatokat, böngészési szokásaidat a
                    vásárlási szokások vizsgálatához is felhasználjuk személyre
                    szabott hirdetések, ajánlatok megjelenítse érdekében.
                  </td>
                  <td>
                    <a
                      rel="nofollow"
                      className="external text"
                      href="https://www.barion.com/en/privacy-notice/"
                    >
                      Barion Payment Zrt.
                    </a>
                  </td>
                  <td>Utolsó frissüléstől számított 1,5 évig</td>
                </tr>
                <tr className="wikitable-tr">
                  <td>Media and advertiser partners' cookie</td>
                  <td>
                    Célja a Barion rendszer és az adott partner rendszerének
                    eltérő felhasználói azonosítójának szinkronizációja,
                    párosítása. A fenti cookie-k működésük részeként jelzik a
                    partnerek szerverének, hogy töltse le a saját felhasználói
                    azonosító cookie-ját a weboldal látogatójának böngészőjébe.
                    Így a két rendszerben egyidőben, egy böngészőben keletkező
                    azonosítók párosítva lesznek.
                  </td>
                  <td>
                    <a
                      rel="nofollow"
                      className="external text"
                      href="https://www.barion.com/en/privacy-notice/"
                    >
                      Lásd adatkezelési tájékoztató
                    </a>
                  </td>
                  <td>
                    A cookie-król részletes tájékoztatást az egyes partner
                    cookie tájékoztatójában találod. Az ilyen célú cookie-kat
                    használó partnerek listáját a cookie tájékoztatójukra mutató
                    hivatkozással együtt{" "}
                    <a
                      rel="nofollow"
                      className="external text"
                      href="https://docs.barion.com/Barion_Pixel_hozz%C3%A1j%C3%A1rul%C3%A1skezel%C3%A9si_k%C3%B6vetelm%C3%A9nyek#Adatfeldolgozó_partnerek"
                    >
                      itt
                    </a>{" "}
                    találod.
                  </td>
                </tr>
              </tbody>
            </tbody>
          </div>
          <div className="row" style={{ marginTop: 10 }}>
            <p>
              A marketing cookie elhelyezése a látogató hozzájárulását igényli.
              A hozzájárulás hiányában a cookie nem tárolható a böngészőben.
              Módosítása, visszavonása a hozzájárulásnak bármikor megtehető a
              weboldalon. Barion Payment Zrt. a cookie segítségével adatokat
              gyűjt a látogatásokról; információ arról mit kattintanak, melyik
              termék/szolgáltatás iránt érdeklődik a látogató vagy a
              félbehagyott rendelésekről. Adatokat gyűjtenek modellek
              felépítéséhez a látogató viselkedéséről valamint személyreszabott
              ajánlatok és digitális hirdetések előállításához. Cél, hogy
              releváns hirdetések jelenjenek meg a látogatóknak olyan
              termékekről amiért valóban érdeklődnek. Ezek a cookiek biztosítják
              számunkra, hogy elkerüljük az irreleváns reklámokat és ajánlásokat
              és azok csak valóban releváns tartalmak legyenek amire affinis a
              látogató. Barion Payment Zrt. maga kezeli az információt vagy
              átadja szerződött média és hirdető partnereinek.
              <a
                rel="nofollow"
                className="external autonumber"
                href="https://docs.barion.com/Barion_Pixel_hozz%C3%A1j%C3%A1rul%C3%A1skezel%C3%A9si_k%C3%B6vetelm%C3%A9nyek#Adatfeldolgozó_partnerek"
              >
                [1]
              </a>
              . Ebből a célból ezen partnerek azonosítói is eltárolásra kerülnek
              a Barion cookie-k mellett. A hozzájárulás ezen cookiek tárolását
              is lehetővé teszi. További részleteket az{" "}
              <a
                rel="nofollow"
                className="external text"
                href="https://www.barion.com/en/privacy-notice/"
              >
                adatkezelési tájékoztatóban
              </a>{" "}
              olvashatsz az adatok felhazsnálásáról.
            </p>
          </div>
          <div className="row" style={{ marginTop: 10 }}>
            <h2>Adatfeldolgozó partnerek</h2>
          </div>
          <div className="row" style={{ marginTop: 10 }}>
            <p>
              mint felhasználó a Barion Marketing Cloud-hoz és a Barion Pixelhez
            </p>
            <br />
          </div>
          <div className="row" style={{ marginBottom: 40 }}>
            <ul><li>DataMe Kft. 1118 Budapest, Ugron Gábor utca 35. <br/></li></ul>
          </div>
        </div>
      </React.Fragment>
    );
  }
}
